import { render, staticRenderFns } from "./Bebidas.vue?vue&type=template&id=f981058a"
import script from "./Bebidas.vue?vue&type=script&lang=js"
export * from "./Bebidas.vue?vue&type=script&lang=js"
import style0 from "./Bebidas.vue?vue&type=style&index=0&id=f981058a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports